import { render, staticRenderFns } from "./SearchResultPostItem.vue?vue&type=template&id=ae70b4d0&scoped=true"
import script from "./SearchResultPostItem.vue?vue&type=script&lang=js"
export * from "./SearchResultPostItem.vue?vue&type=script&lang=js"
import style0 from "./SearchResultPostItem.vue?vue&type=style&index=0&id=ae70b4d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae70b4d0",
  null
  
)

export default component.exports